var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bell_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-M---Header-Menu-L1",
    transform: "translate(-25.000000, -486.000000)",
    fill: "#1D1C1C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-dei-servizi",
    transform: "translate(0.000000, 412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell_white",
    transform: "translate(25.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.472027972,13 L14.527972,13 C14.7902098,13 15,12.7460938 15,12.4160156 C15,6.88085938 12.8234266,2.97070312 7.97202797,2.7421875 L7.97202797,0.9140625 L9.44055944,0.9140625 C9.7027972,0.9140625 9.88636364,0.7109375 9.88636364,0.45703125 C9.88636364,0.203125 9.7027972,0 9.44055944,0 L5.55944056,0 C5.2972028,0 5.11363636,0.203125 5.11363636,0.45703125 C5.11363636,0.7109375 5.32342657,0.9140625 5.55944056,0.9140625 L7.02797203,0.9140625 L7.02797203,2.7421875 C2.2027972,2.97070313 0,6.88085938 0,12.4160156 C0,12.7207031 0.20979021,13 0.472027972,13 Z M7.5,3.88476562 C11.8531469,3.88476562 13.7937063,7.109375 14.0559441,11.8066406 L0.97027972,11.8066406 C1.20629371,7.109375 3.14685315,3.88476562 7.5,3.88476562 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5775209,16 L0.446518658,16 C0.210126427,16 0,16.2162162 0,16.4864865 C0,16.7567568 0.210126427,17 0.446518658,17 L14.5512551,17 C14.8139131,17 14.9977737,16.7837838 14.9977737,16.5135135 C15.0240396,16.2432432 14.8139131,16 14.5775209,16 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.a60ed848cf61b151bb2bb5a351900aac.svg";
export { ForwardRef as ReactComponent };